import pluralize from 'pluralize';
const defaultUnitName = 'hour';
const defaultUnitNameShort = 'hr';
export const getUnitName = function getUnitName(unitName) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return unitName || (options.short ? defaultUnitNameShort : defaultUnitName);
};
export const pluralizeUnitName = (amount, unitName) => pluralize(getUnitName(unitName), amount.toNumber());